export default __webpack_public_path__ + "static/media/iconmonstr-instagram-11.eb68d756.svg";